import React, {ChangeEvent, useState} from "react";
import {Helmet} from "react-helmet-async";
import {
    Grid,
    Divider as MuiDivider,
    Typography,
    Button,
    Stack,
    CardContent,
    Card,
    Alert as MuiAlert, Tabs, Tab, FormGroup, FormControlLabel, Checkbox
} from "@mui/material";

import {Formik} from "formik";
import * as Yup from "yup";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import Loader from "../../components/Loader";
import SnackbarNotification from "../../components/SnackbarNotification";
import InlineMedia from "../../components/inline-media/InlineMedia";
import TabPanel from "../components/TabPanel";
import GeneralInfoCategory from "./fieldGroups/GeneralInfoCategory";
import SeoCategory from "./fieldGroups/SeoCategory";
import VideoCategory from "./fieldGroups/VideoCategory";
import CategoryMultiEditTranslate from "./fieldGroups/translate/CategoryMultiEditTranslate";

// GraphQL
import {FetchResult} from "@apollo/client";
import {
    CategoryMultiEditQuery,
    InlineMediaUploadMutation,
    useCategoryMultiEditQuery,
    useInlineMediaUploadMutation,
    useMultiResetCategoryMutation,
    useMultiUpdateCategoryMutation,
} from "../../graphql/category/category.graphql-gen";

// Types
import {MediaItemType} from "../../types/inlineMedia";

// Icons
import {Save as SaveIcon} from "react-feather";
import {X as CloseIcon} from "react-feather";

// Styling
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import {spacing} from "@mui/system";
import styled from "styled-components/macro";
import {ContentElementItemType} from "../../types/inlineContentElementType";
import InlineContentElement from "../../components/inline-content-element/InlineContentElement";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import Tree from "../../components/tree/Tree";
import {shallowEqual} from "react-redux";
import {InlineMediaUploadArticleMutation} from "../../graphql/article/article.graphql-gen";



const Alert = styled(MuiAlert)(spacing);
const Divider = styled(MuiDivider)(spacing);


const validationSchema = Yup.object().shape({});

const CategoryMultiEdit: React.FC = () => {
    let title: string = 'Category Multi Edit'
    let dataObj: any = {};
    const params = useParams();
    const id = params.id ? params.id : '';
    const inlineModels: string[] = ['images', 'headerImages', 'files'];
    const navigate = useNavigate();
    const model: string = 'Category';
    const multipleSelect: boolean = false;
    let fromMediaCenter: boolean = false;
    const location: any = useLocation();


    const {data: data, error: error, loading: loading} = useCategoryMultiEditQuery({
        variables: {ids: location.state.ids, model, fields: inlineModels, mediacenter: location.state?.fromMediaCenter},
        onCompleted: (data: CategoryMultiEditQuery) => {

            setState({});
            setInicialValue({});

            if (data.inlineMedia) {
                data.inlineMedia.map(item => {
                    switch (item.field) {
                        case 'images':
                            setImages(item.inlineMedia);
                            break;
                        case 'headerImages':
                            setHeaderImages(item.inlineMedia);
                            break;
                        case 'files':
                            setFiles(item.inlineMedia);
                            break;
                    }
                })
            }
        }
    });
    const [multiUpdateCategory] = useMultiUpdateCategoryMutation()
    const [inlineMediaUpload] = useInlineMediaUploadMutation();
    const [multiResetCategory] = useMultiResetCategoryMutation();

    // States
    const [updated, setUpdated] = useState(false);
    const [images, setImages] = useState<any>(dataObj.category ? dataObj.category.images : {});
    const [mediaItems, setMediaItems] = useState<any>(dataObj.category ? dataObj.category.images.items : []);
    const [headerImages, setHeaderImages] = useState<any>(dataObj.category ? dataObj.category.headerImages : {});
    const [headerImagesItems, setHeaderImagesItems] = useState<any>(dataObj.category ? dataObj.category.headerImages.items : []);
    const [files, setFiles] = useState<any>(dataObj.category ? dataObj.category.files : {});
    const [filesItems, setFilesItems] = useState<any>(dataObj.category ? dataObj.category.files.items : []);
    const [contentElements, setContentElements] = useState<any>(dataObj.category ? dataObj.category.contentElements : []);
    const [removedMedia, setRemovedMedia] = useState<any[]>([]);
    const [loader, setLoader] = useState<boolean>(false);
    const [state, setState] = useState<any>();
    const [tabValue, setTabValue] = useState(location.state?.submodelName ? 3 : (location.state?.fromMediaCenter ? 2 : 0));
    const [checked, setChecked] = useState(dataObj.categoriesThree ? dataObj.categoriesThree.checked : []);
    const [expanded, setExpanded] = useState(dataObj.categoriesThree ? dataObj.categoriesThree.expanded : []);
    const [open, setOpen] = useState<boolean>(false);
    const [inicialValue, setInicialValue] = useState<any>();

    const [userId, setUserId] = useState<any>();

    const [template, setTemplate] = useState(1);


    // Set loading
    if (loading  || loader) {
        return <Loader/>
    }

    // Handle error
    if (error ) {
        return (
            <Alert mb={4} severity="error">
                Error!
            </Alert>
        );
    }

    // Set data
    if (data ) {
        dataObj = data
    }


    //------------------------------- Public methods -------------------------------------

    // Handle save action
    const onSaveCategory = (fieldName?: any, fieldType?: any, isMultiple?: any, submodelId?: any, submodelName?: string) => {
        updateCategoryMultiEditMutation(state, fieldName, fieldType, isMultiple, submodelId, submodelName)

        setInicialValue({
            "data": state, "images": mediaItems, "headerImages": headerImagesItems,
            "contentElements": contentElements, "checked": checked
        });
    }

    // Update category mutation
    const updateCategoryMultiEditMutation = (data: any, fieldName?: string, fieldType?: string, isMultiple?: boolean, submodelId?: any, submodelName?: string) => {

        multiUpdateCategory({
            variables: {
                model,
                ids: location.state.ids,
                data,
                parents: checked,
                images: mediaItems,
                headerImages: headerImagesItems,
                files: filesItems,
                removedMedia,
                contentElements,
                temp: fromMediaCenter
            }
        }).then(r => {
            setUpdated(true)
            setRemovedMedia([])

            setTimeout(() => {
                setUpdated(false);
            }, 3000)
            if (fromMediaCenter) {
                navigate(`/mediacenter/`, {
                    replace: true,
                    state: {fieldName, fieldType, isMultiple, modelName: model, modelIds: location.state.ids, submodelId, submodelName}
                })
            }

        }).catch(error => {
            return <SnackbarNotification message="Error, please try again later." open={true} type={'error'}/>
        });
    }

    //Back to ListView
    const backToListView = () => {
        multiResetCategory({
            variables: {
                model,
                ids: location.state.ids
            }
        }).then(r => {
            navigate(`/categories`, {replace: true})
        }).catch(error => {
            return <SnackbarNotification message="Error, please try again later." open={true} type={'error'}/>
        });
    }

    const openDialog = () => {
            const hasChanged = !shallowEqual(inicialValue, {
                "data": state, "images": mediaItems, "headerImages": headerImagesItems,
                "contentElements": contentElements, "checked": checked
            });
            if (hasChanged) {
                setOpen(true);
            } else {
                backToListView()
            }
    }
    // Close snackbar notification
    const closeDialog = () => {
        setOpen(false);
    }

    // Add media
    const onAddMediaHandler = (files: any) => {
        setLoader(true);
        inlineMediaUpload({
            variables: {
                id,
                model,
                field: 'images',
                images: files
            }
        }).then((res: FetchResult<InlineMediaUploadMutation>) => {
                const addedFiles = res.data?.inlineMediaUpload;
                setMediaItems((prevState: any) => {
                    if (addedFiles) {
                        return [...prevState, ...addedFiles];
                    }
                });
                setLoader(false);
            }
        ).catch(error => {
            return <SnackbarNotification message="Error, please try again later." open={true} type={'error'}/>
        })
    }
    const onAddHeaderImagesHandler = (files: any) => {
        setLoader(true);
        inlineMediaUpload({
            variables: {
                id,
                model,
                field: 'headerImages',
                images: files
            }
        }).then((res: FetchResult<InlineMediaUploadMutation>) => {
                const addedFiles = res.data?.inlineMediaUpload;
                setHeaderImagesItems((prevState: any) => {
                    if (addedFiles) {
                        return [...prevState, ...addedFiles];
                    }
                });
                setLoader(false);
            }
        ).catch(error => {
            return <SnackbarNotification message="Error, please try again later." open={true} type={'error'}/>
        })
    }
    const onAddFilesHandler = (files: any) => {
        setLoader(true);
        inlineMediaUpload({
            variables: {
                id,
                model,
                field: 'files',
                images: files
            }
        }).then((res: FetchResult<InlineMediaUploadArticleMutation>) => {
                const addedFiles = res.data?.inlineMediaUpload;
                setFilesItems((prevState: any) => {
                    if (addedFiles) {
                        return [...prevState, ...addedFiles];
                    }
                });
                setLoader(false);
            }
        ).catch(error => {
            return <SnackbarNotification message="Error, please try again later." open={true} type={'error'}/>
        })
    }

    // Update media
    const onMediaUpdateHandler = (updateData: MediaItemType) => {
        const foundIndex = mediaItems.findIndex((item: MediaItemType) => item.id == updateData.id);
        mediaItems[foundIndex] = updateData;
        setMediaItems(mediaItems)
    }
    const onHeaderImagesUpdateHandler = (updateData: MediaItemType) => {
        const foundIndex = headerImagesItems.findIndex((item: MediaItemType) => item.id == updateData.id);
        headerImagesItems[foundIndex] = updateData;
        setHeaderImagesItems(headerImagesItems)
    }
    const onFilesUpdateHandler = (updateData: MediaItemType) => {
        const foundIndex = filesItems.findIndex((item: MediaItemType) => item.id == updateData.id);
        filesItems[foundIndex] = updateData;
        setFilesItems(filesItems)
    }

    // Remove media
    const onMediaRemoveHandler = (id: number | string) => {
        setRemovedMedia(prevState => [...prevState, id])
        setMediaItems((prevState: MediaItemType[]) => prevState.filter(item => item.id !== id));
    }
    const onHeaderImagesRemoveHandler = (id: number | string) => {
        setRemovedMedia(prevState => [...prevState, id])
        setHeaderImagesItems((prevState: MediaItemType[]) => prevState.filter(item => item.id !== id));
    }
    const onFilesRemoveHandler = (id: number | string) => {
        setRemovedMedia(prevState => [...prevState, id])
        setFilesItems((prevState: MediaItemType[]) => prevState.filter(item => item.id !== id));
    }

    const onMediaBrowseHandler = () => {
        fromMediaCenter = true;
        onSaveCategory('images', images.fieldType, images.isMultiple);
    }
    const onHeaderImagesBrowseHandler = () => {
        fromMediaCenter = true;
        onSaveCategory('headerImages', headerImages.fieldType, headerImages.isMultiple);
    }
    const onFilesBrowseHandler =() => {
        fromMediaCenter = true;
        onSaveCategory('files', files.fieldType, files.isMultiple);
    }

    // This function is called when the select changes
    const inputHandler = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, field?: string, type?: string, values?: any[]) => {
        let fieldName = '';
        let value: any;

        if (type) {

            // @ts-ignore
            fieldName = field;
            value = values
        } else {

            // Input fields not checkbox
            if (event.target && event.target.type !== 'checkbox') {
                fieldName = event.target.name;
                value = event.target.value;
            }

            // Input fields checkbox
            if (event.target && event.target.type === 'checkbox') {
                fieldName = event.target.name;
                // @ts-ignore
                value = event.target.checked;
            }

            if (field) {
                fieldName = field
                value = event
            }
        }
        // Update select value
        setState({...state, [fieldName]: value});


    };


    //------------------------ Inline content element methods --------------------------

    // Add content element
    const onAddContentElementHandler = (element: ContentElementItemType) => {
        setContentElements((prevState: any) => {
            if (element) {
                return [...prevState, element];
            }
        });
    }

    // Update content element
    const onContentElementUpdateHandler = (updateData: ContentElementItemType) => {
        // const foundIndex = contentElements.findIndex((item: ContentElementItemType) => item.id == updateData.id);
        const updateContentElements = contentElements.map((el: ContentElementItemType) => {
            if (el.id == updateData.id) {
                return updateData
            } else {
                return el;
            }
        });

        setContentElements(updateContentElements);
    }

    // Remove content element
    const onContentElementRemoveHandler = (id: number | string) => {
        setContentElements((prevState: ContentElementItemType[]) => prevState.filter(item => item.id !== id));
    }

    // Remove media from content element
    const onContentElementMediaRemoveHandler = (id: number | string) => {
        setRemovedMedia(prevState => [...prevState, id])
    }


    // Handle tab change
    const handleTabChange = (event: any, newValue: any) => {
        setTabValue(newValue);
    };

    // Set tub properties
    const tabsProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    //Set tree handlerers
    const treeHandlerCheck = (checkedArr: any, targetNode: any) => {
        if (multipleSelect) {
            setChecked(checkedArr)
        } else {
            if (checkedArr.length != 0) {
                setChecked([targetNode.value.toString()])
            } else {
                setChecked([]);
            }
        }
    }
    const treeHandlerExpand = (event: any) => {
        setExpanded(event)
    }

    // const templateChange = (event: any) => {
    //     setTemplate(event.target.value);
    //
    //     setImages(dataObj.category.images);
    //     setHeaderImages(dataObj.category.headerImages);
    //     setMediaItems(dataObj.category.images?.items);
    //     setHeaderImagesItems(dataObj.category.headerImages?.items);
    //     setContentElements(dataObj.category.contentElements);
    //     if (dataObj.category && dataObj.category.category) {
    //         setState(dataObj.category.category);
    //     }
    //     setChecked(dataObj.categoriesThree.checked);
    //     setExpanded(dataObj.categoriesThree.expanded);
    //
    // };


    return (
        <React.Fragment>
            <Helmet title="Category Multi Edit"/>

            <Grid justifyContent="space-between" container spacing={10}>
                <Grid item>
                    <Typography variant="h3" gutterBottom >
                        {title}
                    </Typography>

                    <Typography variant="h4" gutterBottom >
                        {dataObj.categoryMultiEdit.map((item: any, index: number) => {
                            if(item.category ){
                                return item.category.title
                            }
                        }).join(', ')}
                    </Typography>

                </Grid>
                <Grid item>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" color="inherit" onClick={openDialog}>
                            <CloseIcon/>
                        </Button>

                        <Button type="submit" variant="contained" color="primary" form="single-form">
                            <SaveIcon/>
                        </Button>
                    </Stack>
                </Grid>
            </Grid>

            <Divider my={6}/>

            {state &&
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Formik
                                    initialValues={state}
                                    validationSchema={validationSchema}
                                    onSubmit={onSaveCategory}
                                    validateOnChange={true}
                                    validateOnMount={true}
                                >
                                    {({
                                          errors,
                                          handleBlur,
                                          handleChange,
                                          handleSubmit,
                                          touched,
                                          values,
                                      }) => (
                                        <form onSubmit={handleSubmit} id="single-form">
                                            <div className="tabs-wrapper">
                                                <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable"
                                                      allowScrollButtonsMobile>
                                                    <Tab label="General" {...tabsProps(0)} />
                                                    <Tab label="Parent category" {...tabsProps(1)} />
                                                    <Tab label="Media" {...tabsProps(2)} />
                                                    <Tab label="Promotions" {...tabsProps(3)} />
                                                    <Tab label="Translate Germany" {...tabsProps(4)} />
                                                </Tabs>
                                            </div>
                                            <div className="scrollable-content">
                                                <TabPanel value={tabValue} index={0}>
                                                    {/*<Grid container spacing={6}>*/}
                                                    {/*    <Grid item xs={12} md={6} mb={5}>*/}
                                                    {/*        <FormControl fullWidth>*/}
                                                    {/*            <InputLabel>Template</InputLabel>*/}
                                                    {/*            <Select*/}
                                                    {/*                value={template}*/}
                                                    {/*                label="Template"*/}
                                                    {/*                onChange={templateChange}*/}
                                                    {/*            >*/}
                                                    {/*                <MenuItem value={1}>Template 1</MenuItem>*/}
                                                    {/*                <MenuItem value={2}>Template 2</MenuItem>*/}
                                                    {/*                <MenuItem value={3}>Template 3</MenuItem>*/}
                                                    {/*            </Select>*/}
                                                    {/*        </FormControl>*/}
                                                    {/*    </Grid>*/}
                                                    {/*</Grid>*/}

                                                    <GeneralInfoCategory
                                                        data={dataObj}
                                                        onChange={(e, field, type, values) => {
                                                            inputHandler(e, field, type, values);
                                                            handleChange(e);
                                                        }}
                                                        touched={touched}
                                                        errors={errors}
                                                        values={values}
                                                        state={state}
                                                        multiEdit={true}
                                                    />


                                                </TabPanel>
                                                <TabPanel value={tabValue} index={1}>

                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Parent category
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Tree
                                                        data={dataObj.categoriesThree}
                                                        checked={checked}
                                                        expanded={expanded}
                                                        onCheck={treeHandlerCheck}
                                                        onExpand={treeHandlerExpand}/>

                                                    <FormGroup >
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                name="clearParent"
                                                                checked={state.clearParent ? state.clearParent : false}
                                                                onChange={(e) =>{inputHandler(e)}}
                                                            />
                                                        } label="Clear"/>
                                                    </FormGroup>
                                                </TabPanel>
                                                <TabPanel value={tabValue} index={2}>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Images
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <InlineMedia
                                                        items={mediaItems}
                                                        fieldType={images.fieldType}
                                                        allowedExtensions={images.allowedExtensions}
                                                        isMultiple={images.isMultiple}
                                                        onAdd={onAddMediaHandler}
                                                        onUpdate={onMediaUpdateHandler}
                                                        onDelete={onMediaRemoveHandler}
                                                        isBrowseMedia={false}
                                                        browseMedia={onMediaBrowseHandler}
                                                    />

                                                        <FormGroup  className="clear-check-top">
                                                            <FormControlLabel control={
                                                                <Checkbox
                                                                    name="clearImages"
                                                                    checked={state.clearImages ? state.clearImages : false}
                                                                    onChange={(e) =>{inputHandler(e)}}
                                                                />
                                                            } label="Clear"/>
                                                        </FormGroup>

                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Divider mb={10}/>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Header Image
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <InlineMedia
                                                        items={headerImagesItems}
                                                        fieldType={headerImages.fieldType}
                                                        allowedExtensions={headerImages.allowedExtensions}
                                                        isMultiple={headerImages.isMultiple}
                                                        onAdd={onAddHeaderImagesHandler}
                                                        onUpdate={onHeaderImagesUpdateHandler}
                                                        onDelete={onHeaderImagesRemoveHandler}
                                                        isBrowseMedia={false}
                                                        browseMedia={onHeaderImagesBrowseHandler}
                                                    />
                                                    <FormGroup className="clear-check-top">
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                name="clearHeaderImages"
                                                                checked={state.clearHeaderImages ? state.clearHeaderImages : false}
                                                                onChange={(e) =>{inputHandler(e)}}
                                                            />
                                                        } label="Clear"/>
                                                    </FormGroup>

                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Divider mb={10}/>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Files
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <InlineMedia
                                                        items={filesItems}
                                                        fieldType={files.fieldType}
                                                        allowedExtensions={files.allowedExtensions}
                                                        isMultiple={files.isMultiple}
                                                        onAdd={onAddFilesHandler}
                                                        onUpdate={onFilesUpdateHandler}
                                                        onDelete={onFilesRemoveHandler}
                                                        isBrowseMedia={false}
                                                        browseMedia={onFilesBrowseHandler}/>
                                                    <FormGroup className="clear-check-top">
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                name="clearHeaderImages"
                                                                checked={state.clearFiles ? state.clearFiles : false}
                                                                onChange={(e) =>{inputHandler(e)}}
                                                            />
                                                        } label="Clear"/>
                                                    </FormGroup>

                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Divider mb={10}/>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Video
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    <VideoCategory
                                                        data={dataObj}
                                                        onChange={(e, field) => {
                                                            handleChange(e);
                                                            inputHandler(e, field)
                                                        }}
                                                        touched={touched}
                                                        errors={errors}
                                                        values={values}
                                                        state={state}
                                                        multiEdit={true}
                                                    />
                                                </TabPanel>
                                                <TabPanel value={tabValue} index={3}>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Promotions
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <SeoCategory
                                                        data={dataObj}
                                                        onChange={(e, field) => {
                                                            handleChange(e);
                                                            inputHandler(e, field)
                                                        }}
                                                        touched={touched}
                                                        errors={errors}
                                                        values={values}
                                                        state={state}
                                                        multiEdit={true}
                                                    />
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Divider mb={10}/>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={6}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h6" mb={5}>
                                                                Content Elements
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <InlineContentElement
                                                        items={contentElements}
                                                        onAdd={onAddContentElementHandler}
                                                        onUpdate={onContentElementUpdateHandler}
                                                        onDelete={onContentElementRemoveHandler}
                                                        onMediaDelete={onContentElementMediaRemoveHandler}
                                                        multiEdit={true}
                                                    />
                                                    <FormGroup className="clear-check-top">
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                name="clearContentElements"
                                                                checked={state.clearContentElements ? state.clearContentElements : false}
                                                                onChange={(e) =>{inputHandler(e)}}
                                                            />
                                                        } label="Clear"/>
                                                    </FormGroup>

                                                </TabPanel>
                                                <TabPanel value={tabValue} index={4}>

                                                    <CategoryMultiEditTranslate
                                                        data={dataObj}
                                                        onChange={(e, field) => {
                                                            handleChange(e);
                                                            inputHandler(e, field)
                                                        }}
                                                        touched={touched}
                                                        errors={errors}
                                                        values={values}
                                                        state={state}
                                                        multiEdit={true}
                                                    />


                                                </TabPanel>
                                            </div>

                                        </form>
                                    )}
                                </Formik>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            }
            {updated &&
                <SnackbarNotification message="Saved successfully" open={updated}/>
            }

            <ConfirmationDialog
                message="Are you sure you want to leave without saving?"
                title="Leave page"
                open={open}
                button="Confirm"
                onConfirm={backToListView}
                onCancel={closeDialog}/>
        </React.Fragment>
    );
}

export default CategoryMultiEdit;
